import React, { useEffect, useState } from "react";
import { Image } from "@arctheme-components/elements/Image/Image";
import { useAlpineStore } from "@arctheme-hooks/useAlpineStore";

export const ProductImages = ({ product, productUrl, isLazy = true }) => {
  const store: any = useAlpineStore("modelview");
  let isModelView = false;


  if (store) {
    isModelView = store.isModelView;
  }
  const [modelView, setModelView] = useState(isModelView);
  const [isHovered, setIsHovered] = useState(false);

  const productImageWidth = "300";

  let imageIndex = 0;
  let hoverIndex = 1;


  if (product.image) {
    product.images = [product.image];
  }

  if (!product.images) {
    product.images = [product.image];
  }

  if (product.media) {
    product.images = product.media;
  }

  const onlyFirstImage =
    product?.images?.length === 2 &&
    product?.images?.[1]?.src?.toLowerCase().includes("_s") &&
    !/(_s[^_])/i.test(product?.images?.[1]?.src);
  let secondImageIsSwatch =
    product?.images?.[1]?.src?.toLowerCase().includes("_s") &&
    !/(_s[^_])/i.test(product?.images?.[1]?.src);

  if (product?.images?.length < 2) {
    secondImageIsSwatch = true;
  }

  if (modelView && !onlyFirstImage) {
    if (product?.images?.length - 1 > imageIndex) {
      imageIndex = product?.images?.length - 1;
      hoverIndex = 0;
    } else {
      imageIndex = 0;
      hoverIndex = 0;
    }
  } else {
    hoverIndex = product?.images?.length - 1;
  }

  const getImageUrl = (image) => {
    if (typeof image === "object" && image !== null && image.src) {
      return image?.src;
    }
    return image;
  };

  useEffect(() => {
    const handleModelViewToggle = (event) => {
      setModelView(event.detail.isModelView);
    };

    window.addEventListener("modelview-toggled", handleModelViewToggle);

    return () => {
      window.removeEventListener("modelview-toggled", handleModelViewToggle);
    };
  }, []);

  return (
    <a
      href={`${productUrl}`}
      className="w-full product-images"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {!product?.images && product?.image && (
        <Image imageUrl={getImageUrl(product.image)} isLazy={isLazy} width={"300"} />
      )}
      {product?.images[
        isHovered && !secondImageIsSwatch ? hoverIndex : imageIndex
      ] && (
        <Image
          imageUrl={getImageUrl(
            product.images[
              isHovered && !secondImageIsSwatch ? hoverIndex : imageIndex
            ],
          )}
          width={productImageWidth}
          isLazy={isLazy}
        />
      )}
    </a>
  );
};
